import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'

import { LOCAL_STORAGE_KEY_MAP } from '@/lib/constants/platform'
import { deleteAccountMutation } from '@/lib/queries/business/v1/user/withdraw/mutations'

export const useDeleteAccount = () => {
  const navigate = useNavigate()

  const { mutateAsync: deleteAccount, isPending: isDeletingAccount } = useMutation(deleteAccountMutation)

  const handleClickDeleteButton = async () => {
    await deleteAccount(null, {
      onSuccess: () => {
        localStorage.removeItem(LOCAL_STORAGE_KEY_MAP.token)
        void navigate({ to: '/sign-in' })
        toast.success('Account has been successfully deleted', {
          duration: 6000,
        })
      },
      onError: () => {
        toast.error('Failed to delete the account', {
          duration: 6000,
        })
      },
    })
  }

  return {
    isDeletingAccount,
    handleClickDeleteButton,
  }
}
